import React from "react";
import HubspotForm from "./HubspotForm";
import * as styles from "../styles/footer.module.css";
import { graphql, useStaticQuery } from "gatsby";
import { Icon } from "@iconify/react";

import { useTranslation, useI18next } from "gatsby-plugin-react-i18next";
export default function ContactFooter() {
  const data = useStaticQuery(
    graphql`
      query FooterContactInfo {
        siteInfo: site {
          siteMetadata {
            copyright
            email
            linkedinLink
            phoneDisplay
            xingLink
            address {
              city
              company
              country
              street
              zip
            }
          }
        }

        hubspotForms: allHubspotForm {
          nodes {
            id
            portalId
            name
            submitText
            metaData {
              name
              value
            }
            formFieldGroups {
              fields {
                fieldType
                description
                objectTypeId
                name
                enabled
                defaultValue
                label
                required
              }
            }
          }
        }
      }
    `
  );
  const currentLanguage = useI18next().language;
  const hubspotForm = data.hubspotForms.nodes.find(
    (form) => form.name === "lineup.de footer " + currentLanguage
  );
  const { address, email, phoneDisplay } = data.siteInfo.siteMetadata;
  const { t } = useTranslation();
  return (
    <section id="ready-to-lineup" className="section-bg">
      <div className="container " data-aos="fade-up">
        <div className="sectionTitle">
          <h2 id="kontakt">{t("Kontakt")}</h2>
          <h3>
            <span>{t("Ready to Line Up?") + " "}</span>
            <br />
            {t("Kontaktieren Sie uns!")}
          </h3>
          <p>
            {t(
              "Persönlich nah, europaweit und in China für Sie da - wann gehören Sie zu unseren zufriedenen Kunden?"
            )}
          </p>
        </div>
        <div className="row contentbox" data-aos="fade-up" data-aos-delay="100">
          <div className="col-lg-6">
            <div className={styles.infoBox}>
              <div className={styles.icon}>
                <Icon icon="clarity:map-marker-line" />
              </div>
              <h3>{t("Besuchen Sie uns")}</h3>
              <p>
                {address.street}, {address.zip} {address.city}
              </p>
            </div>
            <div className={styles.infoBox}>
              <div className={styles.icon}>
                <Icon icon="bi:envelope" />
              </div>
              <h3>{t("Schreiben Sie uns")}</h3>
              <p>{email}</p>
            </div>
            <div className={styles.infoBox}>
              <div className={styles.icon}>
                <Icon icon="bi:telephone-forward" />
              </div>
              <h3>{t("Rufen Sie uns an")}</h3>
              <p>{phoneDisplay}</p>
            </div>
          </div>
          <div className="col-lg-6">
            <HubspotForm
              region={"na1"}
              portalId={hubspotForm.portalId}
              formId={hubspotForm.id}
              formFieldGroups={hubspotForm.formFieldGroups}
              metaData={hubspotForm.metaData}
              submitText={hubspotForm.submitText}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
